import { type SxProps } from "@mui/material";
import { Text, type TextProps } from "@src/appV2/redesign/system/ui-components";

import { getTimeUntilDeactivationDisplayText } from "./utils/displayTextUtils";

const DYNAMIC_TEXT_DEADLINE_TO_CHART = "{{deadlineToChart}}";

interface ChartingNoncomplianceTextProps {
  text: string;
  deadlineToChart: Date;
  sx?: SxProps;
  variant?: TextProps["variant"];
}

export function ChartingNoncomplianceText({
  text,
  deadlineToChart,
  sx,
  variant,
}: ChartingNoncomplianceTextProps) {
  const parts = text.split(new RegExp(`(${DYNAMIC_TEXT_DEADLINE_TO_CHART})`));
  const deadlineText = getTimeUntilDeactivationDisplayText(deadlineToChart);

  if (parts.length === 1) {
    return (
      <Text sx={sx} variant={variant}>
        {text}
      </Text>
    );
  }

  return (
    // oxlint-disable-next-line typescript/no-misused-spread -- MUI SxProps union includes functions, but spreading in sx is standard MUI pattern
    <Text sx={{ ...sx }}>
      {parts.map((part) =>
        part === DYNAMIC_TEXT_DEADLINE_TO_CHART ? (
          <Text
            key={part}
            variant={variant}
            // oxlint-disable-next-line typescript/no-misused-spread -- MUI SxProps union includes functions, but spreading in sx is standard MUI pattern
            sx={{ display: "inline", ...sx, paddingX: 0 }}
            color={(theme) => theme.palette.error.main}
          >
            {deadlineText}
          </Text>
        ) : (
          // oxlint-disable-next-line typescript/no-misused-spread -- MUI SxProps union includes functions, but spreading in sx is standard MUI pattern
          <Text key={part} variant={variant} sx={{ display: "inline", ...sx, paddingX: 0 }}>
            {part}
          </Text>
        )
      )}
    </Text>
  );
}
